// eslint-disable-next-line import/no-named-as-default
import Config from "react-native-config";

export const appEnv = Config.APP_ENV;
export const baseURL = Config.BASE_URL;
export const searchBaseURL = Config.SEARCH_URL;
export const staticPageBaseURL = Config.STATIC_PAGE_URL;
// Plotline removed

export const codePushKey = Config.CODEPUSH_KEY;
export const appVersion = Config.ANDROID_VERSION_NAME;
export const appVersionCode = Config.ANDROID_VERSION_CODE;
export const sentryDsn = Config.SENTRY_DSN;

export const applinksBaseUrl = Config.APPLINKS_BASE_URL;
export const androidAppStore = Config.ANDROID_APP_STORE;

// Compared against setup-5's version.versionId by UpdateAppModal. react-native-config
// values are strings, and VERSION_CODE was never defined, so the modal never fired.
export const APP_VERSION = Number(Config.ANDROID_VERSION_CODE);
export const isCLApp = true;
export const socketUrl = Config.SOCKET_URL;

// Tracking (movex.geo)
export const trackingEnabled = Config.TRACKING_ENABLED === "true";
export const movexPublishableKey = Config.MOVEX_PUBLISHABLE_KEY || "";

// FingerprintJS Pro (device fraud blocking) — empty key disables the agent
export const fingerprintApiKey = Config.FINGERPRINT_API_KEY || "";

// FORCE UPDATE
// 1.42.3 - 15
// 1.42.4 - 16
// 1.44.4 - 18
// 1.44.7 - 19
// 1.45.0 - 20
// 1.45.1 - 21
// 1.45.2 - 3145923
